import React from 'react'
import './style.sass'
import PropTypes from 'prop-types'

const SearchField = ({ placeholder, value, onChange, disabled }) => {
  return (
    <div className="search-field-container">
      <div className="search-bar-input">
        <i className="fa fa-search" />
        <input 
          type="text" 
          placeholder={placeholder}
          value={value ?? ""}
          onChange={onChange ? (e) => onChange(e.target.value) : () => {}}
          disabled={disabled}
        />
      </div>
    </div>
  )
}

SearchField.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

export default SearchField
